import React, { useMemo } from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loadable from '../utils/loadable';
import ActivityLoader from './ActivityLoader';
import { getProfileGroups } from './domestic/header/headerProfileGroups';
import { defaultContainerSearchLandingPath } from './domestic/header/domesticNavPermissions';

const ContainerSearch = Loadable({
  loader: () => import('../pages/ContainerSearch'),
  loading: ActivityLoader,
});

/**
 * `/` for guests: classic Container Search.
 * For signed-in users: permission-aware container-search landing
 * (intl `/search` or `/d/intl/search`, else domestic shipment).
 */
export default function DefaultLandingRoute(props) {
  const { user, assumeuser } = useSelector((state) => ({
    user: state.user,
    assumeuser: state.assumeuser,
  }));

  const landingPath = useMemo(() => {
    if (!user?.username) return null;
    const grps = getProfileGroups(user, assumeuser);
    return defaultContainerSearchLandingPath(grps, user);
  }, [user, assumeuser]);

  if (
    landingPath &&
    landingPath !== '/' &&
    landingPath !== props.location?.pathname
  ) {
    return <Redirect to={landingPath} />;
  }

  return <ContainerSearch {...props} />;
}
